import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const OrderConfirm = ({ show, onClose, order, refresh }) => {
    const [mealsPeriod, setMealsPeriod] = useState([]);
    const BaseUrl = process.env.REACT_APP_API_BASE_URL;
    const user_id = parseInt(localStorage.getItem("user_id"), 10);
    const [addOnService, setAddOnService] = useState({});

    const fetchitemSchedule = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/item-schedule/items/active`);

            const list = response.data?.data;

            if (Array.isArray(list)) {
                const formatted = list.map(item => ({
                    value: String(item.sno),
                    label: item.itemschedule_name
                }));
                setMealsPeriod(formatted);
            } else {
                setMealsPeriod([]); // fallback to empty array
            }
        } catch (error) {
            console.error('Failed to fetch Meals period:', error);
            setMealsPeriod([]); // fallback to empty array, not object
        }
    };

    const getMealsPeriodLabel = (sno) => {
        if (!Array.isArray(mealsPeriod)) return '';
        const found = mealsPeriod.find(mp => mp.value === String(sno));
        return found?.label || '-';
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    const fetchAddOnService = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/addonservice/getactive`);
            if (response.data && Array.isArray(response.data)) {
                const formatted = response.data.map(item => ({
                    value: String(item.sno),
                    label: item.service,
                    vendor: item.vendor,
                    cost_per_unit: item.cost_per_unit,
                }));
                setAddOnService(formatted);
            }
        } catch (error) {
            console.error('Failed to Add On Service Type:', error);
            setAddOnService({});
        }
    };

    const getServiceName = (serviceId) => {
        if (!serviceId || !Array.isArray(addOnService)) return serviceId;
        const found = addOnService.find(s => s.value === serviceId.toString());
        return found ? found.label : serviceId;
    };

    useEffect(() => {
        fetchAddOnService();
        fetchitemSchedule();
    }, []);

    const days = [
        "Monday", "Tuesday", "Wednesday", "Thursday",
        "Friday", "Saturday", "Sunday"
    ];

    const handleSubmit = () => {

        axios.put(`${BaseUrl}/manage_corporate_order/confirm/${order.id}`)
            .then(response => {
                onClose();
                refresh();
                toast.success("Corder Confirmed Successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Order Confirm Failed");
            });
    };

    return (
        <Modal show={show} onHide={onClose} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title  text-white">Order Confirm</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row mb-4">
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Order Id</label>
                            <div className='d-block'>
                                <label className='text-success font-w600 fs-6 py-0'>{order.catering_id}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Customer Name</label>
                            <div className='d-block'>
                                <label className='text-success font-w600 fs-6 py-0'>{order.customer.customer_name}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Customer Mobile No</label>
                            <div className='d-block'>
                                <label className='text-success font-w600 fs-6 py-0'>{order.customer.customer_number}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Company Name</label>
                            <div className='d-block'>
                                <label className='text-success font-w600 fs-6 py-0'>{order.customer.company_name ? order.customer.company_name : '-'}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Company Mobile No</label>
                            <div className='d-block'>
                                <label className='text-success font-w600 fs-6 py-0'>{order.customer.company_number ? order.customer.company_number : '-'}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Order Date</label>
                            <div className='d-block'>
                                <label className='text-success font-w600 fs-6 py-0'>{formatDate(order.order_date)}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Meals Period</label>
                            <div className='d-block'>
                                <label className='text-success font-w600 fs-6 py-0'>{getMealsPeriodLabel(order.meals_period)}</label>
                            </div>
                        </div>
                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Head Count</label>
                            <div className='d-block'>
                                <label className='text-white bg-primary px-2 rounded font-w600 fs-6 py-1'>{order.head_count}</label>
                            </div>
                        </div>

                        <div className='col-lg-4 d-flex flex-column align-items-start gap-1 mb-2'>
                            <label className='text-black text-start font-w600 fs-7'>Total Cost</label>
                            <div className='d-block'>
                                <label className='text-danger font-w600 fs-3 py-0'>₹ {order.total}</label>
                            </div>
                        </div>
                    </div>
                    <hr></hr>

                    <div className='col-lg-12'>
                        {(order.items?.length > 0 || order.addonservice?.length > 0) && (
                            <div
                                className="p-4 rounded"
                                style={{
                                    backgroundColor: '#f0f5ef',
                                    maxHeight: '330px',
                                    overflowY: 'auto',
                                }}
                            >

                                {/* ===================== ITEMS SECTION ===================== */}
                                {order.items?.length > 0 && (
                                    <>
                                        <h5 className="text-black font-w600 mb-3 fs-4">
                                            <i className="fa-solid fa-circle-check text-primary fs-5"></i> Items
                                        </h5>

                                        {/* Group items by day */}
                                        {days.map((day) => {
                                            const itemsForDay = order.items.filter(item => item.day === day);
                                            if (itemsForDay.length === 0) return null; // skip days with no items

                                            return (
                                                <div key={day} className="mb-4">

                                                    <h6 className="fw-bold text-primary mb-2">{day}</h6>

                                                    <div
                                                        className="d-flex flex-wrap gap-3"
                                                        style={{ rowGap: "15px" }}
                                                    >
                                                        {itemsForDay.map((item, index) => (
                                                            <div
                                                                key={index}
                                                                className="p-3 rounded shadow-sm bg-white"
                                                                style={{
                                                                    width: "calc(33.33% - 10px)", // 3 per row
                                                                    border: "1px solid #e0e0e0",
                                                                }}
                                                            >
                                                                <div className="fw-bold text-black fs-6">
                                                                    {item.name}
                                                                </div>

                                                                <div className="fs-6 text-black mt-1">
                                                                    {item.quantity} {item.unit_name}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>

                                                </div>
                                            );
                                        })}

                                    </>
                                )}

                                {/* ===================== ADDON SERVICES SECTION ===================== */}
                                {order.addonservice?.length > 0 && (
                                    <>
                                        <h5 className="text-black font-w600 mb-3 fs-4 mt-3">
                                            <i className="fa-solid fa-circle-check text-primary fs-5"></i> Add-On Services
                                        </h5>

                                        <div
                                            className="d-flex flex-wrap gap-3"
                                            style={{ rowGap: "15px" }}
                                        >
                                            {order.addonservice.map((addon, index) => (
                                                <div
                                                    key={index}
                                                    className="p-3 rounded shadow-sm bg-white"
                                                    style={{
                                                        width: "calc(50% - 10px)",
                                                        border: "1px solid #e0e0e0",
                                                    }}
                                                >
                                                    <div className="fw-bold text-black fs-6">
                                                        {getServiceName(addon.service)}
                                                    </div>


                                                    <div className="d-flex justify-content-between align-items-center mt-2">
                                                        <div className="fs-6 text-black">
                                                            {addon.quantity} unit(s)
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                )}

                            </div>
                        )}
                    </div>

                    {/* order confirm */}
                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>
                            Order Confirm <i className="fas fa-angle-double-right ms-2"></i>
                        </Link>
                    </div>
                </div>
            </div>
        </Modal >
    );
};

export default OrderConfirm;
